import React, { useState, useEffect } from 'react';
import { Modal, Carousel, Tooltip, OverlayTrigger } from 'react-bootstrap';
import PageLoader from '../subComponents/PageLoader';
import SafeImage from '../subComponents/SafeImage';
import ZoomModal from "./ZoomModal";

const GiftSelectionModal = ({
  showModalPopup,
  onPopupClose,
  errorMsg = null,
  isCheckedWhatsappBox = false,
  handleWhatsappChange,
  proceed,
  selectedGiftOne,
  setSelectedGiftOne,
  showAllGifts = [],
  publicationImage = null,
}) => {
    const [loading, setLoading] = useState(false);
    const [selectedGift, setSelectedGift] = useState(selectedGiftOne || null);
    const [showZoomModal, setShowZoomModal] = useState(false);
    const [zoomImages, setZoomImages] = useState([]);
    const [carouselIndex, setCarouselIndex] = useState(0);
    const [showTooltip, setShowTooltip] = useState(true);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);

    useEffect(() => {
        setShowTooltip(
        'ontouchstart' in window ||
        (navigator.maxTouchPoints > 0 && window.matchMedia('(hover: none)').matches)
        );
    }, []);


    useEffect(() => {
        if (!selectedGiftOne?.id && showAllGifts.length > 0) {
            setSelectedGift(showAllGifts[0]);
            setSelectedGiftOne?.(showAllGifts[0]);
        }
    }, [showAllGifts, selectedGiftOne]);

    const handleImageZoom = (images, index = 0) => {
        setZoomImages(images);
        setCarouselIndex(index);
        setShowZoomModal(true);
    };

    const renderTooltip = (props) => (
        <Tooltip id="zoom-tooltip" className="custom-tooltip-image" {...props}>
        Click to zoom in and view details
        </Tooltip>
    );

    const handleProceed = () => {
        if (selectedGift) {
            // If there are multiple gifts, show confirmation modal
            if (showAllGifts.length > 1) {
                setShowConfirmationModal(true);
            } else {
                // If single gift, proceed directly
                proceed(selectedGift);
            }
        }
    };

    const handleConfirmProceed = () => {
        setShowConfirmationModal(false);
        if (selectedGift) {
            proceed(selectedGift);
        }
    };

    const handleChangeGift = () => {
        setShowConfirmationModal(false);
    };

    const handleConfirmationImageZoom = (images, index = 0) => {
        setZoomImages(images);
        setCarouselIndex(index);
        setShowZoomModal(true);
    };

    const setAcceptWhatsapp = () => {
        handleWhatsappChange();
    };

    const renderImagePreview = (gift) => {
        const imageBlock = (
        <div
            className="mr-2"
            onClick={(e) => {
            e.stopPropagation();
            handleImageZoom(gift.images, 0);
            }}
            style={{ cursor: 'zoom-in' }}
        >
            {gift.images.length > 1 ? (
            <Carousel indicators={false} controls={false} interval={2000} fade={true}>
                {gift.images.map((imgUrl, i) => (
                <Carousel.Item key={i} style={{ width: "100px", height: "60px", overflow: "hidden" }}>
                    <SafeImage
                    src={imgUrl}
                    alt={`${gift.name} ${i + 1}`}
                    className="img-thumbnail"
                    style={{ width: "100px", height: "60px", objectFit: "cover", cursor: 'zoom-in' }}
                    />
                </Carousel.Item>
                ))}
            </Carousel>
            ) : (
            <SafeImage
                src={gift.images[0]}
                alt={gift.name}
                className="img-thumbnail"
                style={{ cursor: 'zoom-in' }}
            />
            )}
        </div>
        );

        return !showTooltip ? (
        <OverlayTrigger placement="top" overlay={renderTooltip}>
            {imageBlock}
        </OverlayTrigger>
        ) : imageBlock;
    };

    return (
        <>
            {loading && <PageLoader />}

            {/* Main Selection Modal */}
            <Modal
                show={showModalPopup}
                onHide={onPopupClose}
                size="md"
                centered
                id="CI-details"
                className="gift-details"
            >
                <Modal.Header closeButton>
                <Modal.Title className="CITitle">Select a gift of your desired choice.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <div className="gift-modal">
                    <div className="brand-logo">
                    <img src={publicationImage} alt="HT Logo" />
                    </div>

                    {showAllGifts.map((gift) => (
                    <div
                        key={gift.id}
                        className={`d-flex align-items-center p-2 mb-2 ${
                        selectedGift?.id === gift.id ? "bg-info-light border-info" : "bg-light"
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                        setSelectedGift(gift);
                        setSelectedGiftOne?.(gift);
                        }}
                    >
                        <div className="form-check mr-2">
                        <input
                            className="form-check-input custom-radio-input"
                            type="radio"
                            name="giftSelect"
                            checked={selectedGift?.id === gift.id}
                            readOnly
                        />
                        </div>

                        {renderImagePreview(gift)}

                        <div>
                        <strong>{gift.name}</strong>
                        <div className="small">{gift.description}</div>
                        </div>
                    </div>
                    ))}

                    <div className="gift-note">
                    <span className="note-label">Note: - </span>
                    <span>
                        Gift images shown are for illustration purposes only. Actual products may vary in appearance.
                    </span>
                    </div>

                    <div className="gift-main mt-1">
                    <input
                        type="checkbox"
                        className="gift-input"
                        id="whatsappConsent"
                        checked={isCheckedWhatsappBox}
                        onChange={setAcceptWhatsapp}
                    />
                    <label className="gift-whatsApp" htmlFor="whatsappConsent">
                        I accept to get the notifications through WhatsApp
                    </label>
                    </div>

                    <div className="giftProceed mx-auto mt-3 mb-2">
                    <button className="btn" onClick={handleProceed}>
                        {showAllGifts.length > 1 ? 'Confirm' : 'Proceed'}
                    </button>
                    </div>
                </div>
                </Modal.Body>
            </Modal>

            {/* Zoom Modal */}
            <ZoomModal
                show={showZoomModal}
                onClose={() => setShowZoomModal(false)}
                images={zoomImages}
                initialIndex={carouselIndex}
            />

            {/* Confirmation Modal - Simple Design */}
            <Modal
                show={showConfirmationModal}
                onHide={handleChangeGift}
                size="sm"
                centered
                className="gift-confirmation-modal"
            >
                <Modal.Header closeButton>
                    <Modal.Title className="CITitle">Confirm Your Gift</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="gift-modal">
                        {selectedGift && (
                            <>
                                <div className="confirmation-gift-card">
                                    <div 
                                        className="confirmation-gift-image"
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleConfirmationImageZoom(selectedGift.images, 0);
                                        }}
                                    >
                                        <SafeImage
                                            src={selectedGift.images && selectedGift.images.length > 0 ? selectedGift.images[0] : ''}
                                            alt={selectedGift.name}
                                            className="img-thumbnail"
                                        />
                                    </div>
                                    <div className="confirmation-gift-details">
                                        <h6 className="confirmation-gift-name">{selectedGift.name}</h6>
                                        <p className="confirmation-gift-desc">{selectedGift.description}</p>
                                    </div>
                                </div>

                                <p className="confirmation-question-text">
                                    Do you want to proceed with this gift?
                                </p>

                                <div className="confirmation-buttons">
                                    <button 
                                        className="btn btn-outline-secondary btn-sm mr-2" 
                                        onClick={handleChangeGift}
                                    >
                                        Change Gift
                                    </button>
                                    <button 
                                        className="btn btn-primary btn-sm" 
                                        onClick={handleConfirmProceed}
                                    >
                                        Proceed
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </Modal.Body>
            </Modal>

        </>
    );
};

export default GiftSelectionModal;
